(function($, undefined) {
	
	'use strict';
	var win = $(window);
	var slideItem;
	
	var checkSlideAnimation = function () {
		var count = 0;
		slideItem.each(function () {
			var t = $(this);
			if (!t.hasClass('is-animated') && !t.hasClass('blog-post')) {
				var itemOffset;

				if (t.hasClass('up')) {
					itemOffset = t.offset().top - 200;
				} else {
					itemOffset = t.offset().top;
				}

				// if window already scrolled past (on refresh), pre-animate items above (win.scrollTop()
				if (win.scrollTop() > (itemOffset + t.outerHeight()) || t.hasClass('slick-slide')) {
					t.addClass('is-animated');
				} else if ((win.scrollTop() + (win.height() / 4) * 3) > (itemOffset)) {
					t.addClass('is-animated').attr('style', 'transition-delay: ' + (count * 3) + '00ms;');
					count++;
				}
			}
		});
	};
	
	var init = function () {
		slideItem = $('.anim-slide');
		
		checkSlideAnimation();
		
		win.scroll(function() {
			checkSlideAnimation();
		});
	};
	
	
	$(window).on('load', function () {
		init();
	});
	
})(jQuery);
